@if (entry.question) {
  <div class="question">{{ entry.question }}</div>
}
<mat-form-field>
  <mat-label>{{ entry.label }}</mat-label>
  <dt-input-spinner
    (increase)="increment()"
    (decrease)="decrement()"
    [plusDisabled]="entry.max != null && control.value >= entry.max"
    [minusDisabled]="entry.min != null && control.value <= entry.min"
    [disabled]="entry.step == null"
  >
    <input matInput type="number" [formControlName]="formIndex" [step]="entry.step" />
  </dt-input-spinner>
  @if (entry.min != null || entry.max != null) {
    <mat-hint i18n>Von {{ entry.min ?? '-∞' }} bis {{ entry.max ?? '∞' }}</mat-hint>
  }
  @if (errors?.min) {
    <mat-error i18n>Mindestens {{ entry.min }}</mat-error>
  }
  @if (errors?.max) {
    <mat-error i18n>Höchstens {{ entry.max }}</mat-error>
  }
  @if (errors?.required) {
    <mat-error i18n>Der Wert darf nicht leer sein</mat-error>
  }
</mat-form-field>
